/**
 * Le nom d'un chantier dans une liste de choix : deux chantiers « Chantier
 * Morin » ne se distinguaient pas. Quand un autre chantier porte le même nom,
 * son code (« CH-4F2A ») le suit.
 *
 * @param {object} c chantier
 * @param {object[]} [liste] chantiers de la même liste
 * @returns {string} le nom à afficher
 */
export function nomDuChantier(c, liste) {
  const nom = String(c?.nom || '').trim();
  const meme = (x) =>
    String(x?.nom || '')
      .trim()
      .toLowerCase() === nom.toLowerCase();
  const homonyme = (liste || []).some((x) => x !== c && x?.id !== c?.id && meme(x));
  if (!homonyme) return nom;
  return nom + ' · ' + (c?.code || '#' + c?.id);
}
